import { href } from "react-router-dom";

import { DEFAULT_LANGUAGE } from "@/constants/languages";
import { LOCALE_PARAM } from "@/constants/routes";
import i18n from "@/i18n";

export function localizedHref(
  path: string,
  params?: Record<string, string | undefined>
): string {
  const currentLanguage = i18n.language.split("-")[0];

  const locale =
    currentLanguage === DEFAULT_LANGUAGE ? undefined : currentLanguage;

  return href(path, { [LOCALE_PARAM]: locale, ...params });
}
